import { Form } from 'react-bootstrap';
import CrudFormLayout from '../../Layout/CrudFormLayout';
import FormLabel from '../../Text/FormLabel';
import ReactInput from '../../InputList/ReactInput/ReactInput';
import StatusCheck from '../StatusCheck';

const StatInfoForm = ({ apiHandler, editData }) => {
    const initialValues = {
        name: editData?.name || '',
        icon_class: editData?.icon_class || '',
        numbers: editData?.numbers || '',
        unit: editData?.unit || '',
        description: editData?.description || '',
        status: editData ? editData?.status : 1,
    };

    const formHandler = (formValue) => {
        if (apiHandler) {
            return apiHandler(formValue);
        }

        console.log(formValue);
        return null;
    };
    return (
        <CrudFormLayout initialValues={initialValues} apiHandler={formHandler}>
            <Form.Group className='mt-3'>
                <FormLabel title='Name' required />

                <ReactInput name='name' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Icon class' required />

                <ReactInput name='icon_class' />
            </Form.Group>
            <Form.Group className='mt-3'>
                <FormLabel title='Numbers' required />

                <ReactInput name='numbers' />
            </Form.Group>
            <Form.Group className='mt-3'>
                <FormLabel title='Unit' />

                <ReactInput name='unit' />
            </Form.Group>
            {/**/}
            {/* <Form.Group className='mt-3'> */}
            {/*     <FormLabel title='Button Title' /> */}
            {/**/}
            {/*     <ReactInput name='button_title' /> */}
            {/* </Form.Group> */}

            <Form.Group className='mt-3'>
                <FormLabel title='Description' required />

                <ReactInput name='description' as='textarea' rows={6} />
            </Form.Group>

            <StatusCheck />
        </CrudFormLayout>
    );
};

export default StatInfoForm;
